@if (!isToggle) {

  <div class="c__checkbox-container">
    <input type="checkbox"
      [name]="nameField"
      [id]="'checkbox-'+uuidInput"
      [value]="value"
      [checked]="checked"
      [readonly]="readonly"
      [disabled]="disabled"
      (change)="clicked()"
      [attr.aria-required]="required"
    />
    <label [for]="'checkbox-' + uuidInput"
      [class]="nameField ? 'c__radio-' + nameField : '' "
      (keyup.enter)="clicked()"
    >
      @if (!!libelleTemplate) {
        <ng-container *ngTemplateOutlet="libelleTemplate" />
      }
      @if (media) {
        <sd-banner [media]="media" />
      }
      <sd-html
        innerClass="{{labelHidden ? 'is-visually-hidden' : ''}} {{customClass}} is-medium"
        [html]="labelTitle"
        tag="span"
      />
    </label>
  </div>

} @else {

  <div class="c__checkbox-container">
    <label
      [for]="'checkbox-' + uuidInput"
      [class]="nameField ? 'c__radio-' + nameField : '' "
      (keyup.enter)="clicked()"
    >
      <input
        type="checkbox"
        [name]="nameField"
        [id]="'checkbox-'+uuidInput"
        [value]="value"
        [checked]="checked"
        [readonly]="readonly"
        [disabled]="disabled"
        (change)="clicked()"
      />
      <span class="c__switch"></span>
      <span class="c__label">{{ labelTitle }}</span>
    </label>
  </div>
}

<ng-content select="[sd-message]" />
